import { render, staticRenderFns } from "./sendEmails.vue?vue&type=template&id=0c28c189&scoped=true&"
import script from "./sendEmails.vue?vue&type=script&lang=js&"
export * from "./sendEmails.vue?vue&type=script&lang=js&"
import style0 from "./sendEmails.vue?vue&type=style&index=0&id=0c28c189&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28c189",
  null
  
)

export default component.exports